<template>
    <div class="pl--0 pr--0 pt--10 client__item__details__sub">
        <template v-if="pageLoading">
            <PageSpinner />
        </template>

        <template v-else-if="pageErr">
            <EmptyPage state="error" @action="handleFetchCheckIns" />
        </template>

        <template v-else>
            <div class="w-100 mt--20">
                <template v-if="!clientCheckIns.length">
                    <EmptyPage
                        state="empty" 
                        icon-name="at" 
                        width="60px" 
                        height="60px"
                        type="check-in"
                    />
                </template>

                <template v-else>
                    <div class="flex align-items-center mb--15 justify-content-between">
                        <p class="text--bold text-gray-400">
                            Check-ins
                        </p>
                        <div class="flex align-items-center gap-2 flex align-items-center justify-content-end width-100">
                            <InnerPageFilter
                                v-model="filter" 
                                page-type="check-in" 
                                @update-filter="handleFilterUpdate"
                            />
                        </div>
                    </div>

                    <div class="flex mt--20">
                        <CustomTable
                            :columns="tableHeaders"
                            :data="clientCheckIns"
                            :is-checkbox="false"
                            table-type="striped"
                            row-type="btns"
                            custom-action
                        >
                            <template #rows="data">
                                <td class="text--upper">
                                    {{ data.checkInType }}
                                </td>
                                <td>{{ $format_date(data.startDate) }}</td>
                                <td>
                                    <Status type="invoice" :value="data.status" />
                                </td>
                            </template>
                            <template #customActionBtns>
                                <List id="projectLink">
                                    <ListItem flex @click="removeIten(data._id)">
                                        <IconSvg name="link" fill="#e04060" width="16px" />
                                        <span class="ml--10 text--xs text--capitalize">Delete</span>
                                    </ListItem>
                                </List>
                            </template>
                        </CustomTable>
                    </div>

                    <div class="flex align-items-center justify-content-between">
                        <p class="text-gray-200 text--medium text--xs">
                            COUNT: <span>{{ clientCheckIns.length }}</span>
                        </p>
                        <pagination v-if="showPagination" :pagination-data="pageData" />
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import {
    EmptyPage,
    PageSpinner,
    CustomTable,
    Status,
    Pagination,
    InnerPageFilter,
    List,
    ListItem,
    IconSvg,
} from "@/components/ui/index";
import { isFilterValueEmpty } from "@/utils/helpers";

export default {
    name: "ClientCheckIns",

    components: {
        CustomTable, 
        Pagination,
        EmptyPage, 
        List,
        ListItem,
        PageSpinner,
        Status,
        InnerPageFilter,
        IconSvg,
    },

    data() {
        return {
            pageLoading: false,
            pageErr: false,
            pageErrMsg: "",
            tableHeaders: [
                { id: "Name", accessorKey: "name", iconName: "user"},
                { id: "Date", accessorKey: "dueDate", iconName: "timer-solid"},
                { id: "Status", accessorKey: "status", iconName: "timer-solid"},
            ],
            filter: {},
        };
    },

    computed: {
        pageData() {
            return this.$store.getters["clients/clientCheckIns"]?.pageData;
        },

        clientCheckIns() {
            return this.$store.getters["clients/clientCheckIns"]?.list;
        },

        accountPlan() {
            return this.$store.getters["subscription/subscriptionInfo"]?.plan || "free";
        },

        showPagination() {
            if (this.pageData?.totalPages > 1) {
                return true;
            } else {
                return false;
            }
        },
    },

    async mounted() {
        await this.handleFetchCheckIns();
    },

    methods: {
        async handleFetchCheckIns(payload) {
            try {
                this.pageErr = false;
                this.pageLoading = true;

                const id = this.$route.params.id;

                if (!id) {
                    this.pageErr = true;
                    return;
                }

                const params = {
                    page: payload?.page || this.pageData?.currentPage,
                    clientId: id,
                };

                await this.$store.dispatch("clients/getClientCheckIns", { id, params });
            } catch (error) {
                this.pageErr = true;
                const errMsg = error?.response?.data?.message || error?.message;
                this.pageErrMsg = errMsg;
            } finally {
                this.pageLoading = false;
            }
        },

        async handleFilterUpdate(serializedFilter) {
            const parsedFilter = JSON.parse(serializedFilter);
            const modifiedParams = {};

            this.filter = parsedFilter;            
            
            if (parsedFilter) {
                const obj = Object.entries(parsedFilter);
                    
                obj.forEach(([key, values]) => {                    
                    if (key && !isFilterValueEmpty(values.value)) {
                        modifiedParams[key] = values.value;
                    }
                });

                console.log({ modifiedParams });               
                // await this.handleFetchClientProjects(modifiedParams);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .title {
        max-width: 170px;
    }
</style>